(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.buskins-collection').forEach((section) => {
      const disclosure = section.querySelector('[data-collection-filter-disclosure]');
      const closeButton = section.querySelector('[data-filter-close]');
      const sortSelect = section.querySelector('[data-collection-sort]');
      const filterForm = section.querySelector('form[id^="CollectionFiltersForm-"]');

      closeButton?.addEventListener('click', () => {
        disclosure?.removeAttribute('open');
      });

      sortSelect?.addEventListener('change', () => {
        filterForm?.submit();
      });

      section.querySelectorAll('[data-filter-options]').forEach((optionsGroup) => {
        const searchInput = optionsGroup.querySelector('[data-filter-value-search]');
        const showMoreButton = optionsGroup.querySelector('[data-filter-more]');
        const valueOptions = Array.from(optionsGroup.querySelectorAll('[data-filter-value]'));

        searchInput?.addEventListener('input', (event) => {
          const searchTerm = event.target.value.trim().toLocaleLowerCase();
          optionsGroup.dataset.searching = searchTerm ? 'true' : 'false';

          valueOptions.forEach((option) => {
            const optionValue = option.dataset.filterValue || '';
            option.hidden = searchTerm ? !optionValue.includes(searchTerm) : false;
          });
        });

        showMoreButton?.addEventListener('click', () => {
          const expanded = optionsGroup.dataset.expanded === 'true';
          optionsGroup.dataset.expanded = expanded ? 'false' : 'true';

          const moreLabel = showMoreButton.querySelector('[data-more-label]');
          const lessLabel = showMoreButton.querySelector('[data-less-label]');
          if (moreLabel) moreLabel.hidden = !expanded;
          if (lessLabel) lessLabel.hidden = expanded;
        });
      });

      const demoCards = Array.from(section.querySelectorAll('[data-demo-card]'));
      if (demoCards.length) {
        const demoInputs = Array.from(section.querySelectorAll('[data-demo-filter]'));
        const demoApply = section.querySelector('[data-demo-filter-apply]');
        const demoClearButtons = Array.from(section.querySelectorAll('[data-demo-filter-clear]'));
        const demoActiveCount = section.querySelector('[data-demo-active-count]');
        const gridResultCount = section.querySelector('[data-grid-result-count]');
        const panelResultCount = section.querySelector('[data-filter-result-count]');
        const demoNoResults = section.querySelector('[data-demo-no-results]');

        const getDemoMatches = () => {
          const selections = new Map();

          demoInputs.filter((input) => input.checked).forEach((input) => {
            const group = input.dataset.demoGroup;
            if (!selections.has(group)) selections.set(group, []);
            selections.get(group).push(input.value);
          });

          const matches = demoCards.filter((card) => {
            const cardGroups = new Map(
              (card.dataset.demoValues || '').split('|').map((entry) => {
                const separator = entry.indexOf(':');
                return [
                  entry.slice(0, separator),
                  entry.slice(separator + 1).split(','),
                ];
              })
            );
            const price = Number(card.dataset.demoPrice || 0);

            return Array.from(selections.entries()).every(([group, selectedValues]) => {
              if (group === 'price') {
                return selectedValues.some((range) => {
                  const [minimum, maximum] = range.split('-').map(Number);
                  return price >= minimum && price <= maximum;
                });
              }

              const cardValues = cardGroups.get(group) || [];
              return selectedValues.some((value) => cardValues.includes(value));
            });
          });

          return { matches, activeCount: demoInputs.filter((input) => input.checked).length };
        };

        const updateDemoCounts = () => {
          const { matches, activeCount } = getDemoMatches();
          if (panelResultCount) panelResultCount.textContent = matches.length;
          if (demoActiveCount) {
            demoActiveCount.textContent = activeCount;
            demoActiveCount.hidden = activeCount === 0;
          }
          return { matches, activeCount };
        };

        const applyDemoFilters = () => {
          const { matches } = updateDemoCounts();
          demoCards.forEach((card) => {
            card.hidden = !matches.includes(card);
          });
          if (gridResultCount) gridResultCount.textContent = matches.length;
          if (demoNoResults) demoNoResults.hidden = matches.length !== 0;
        };

        demoInputs.forEach((input) => {
          input.addEventListener('change', updateDemoCounts);
        });

        demoApply?.addEventListener('click', () => {
          applyDemoFilters();
          disclosure?.removeAttribute('open');
        });

        demoClearButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            demoInputs.forEach((input) => {
              input.checked = false;
            });
            applyDemoFilters();
          });
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && disclosure?.open) {
          disclosure.removeAttribute('open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.buskins-header__nav-item.has-children').forEach((item) => {
    if (item.dataset.submenuReady === 'true') return;

    item.dataset.submenuReady = 'true';
    let closeTimer;

    const openSubmenu = () => {
      window.clearTimeout(closeTimer);
      item.classList.add('is-submenu-open');
    };

    const scheduleSubmenuClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!item.matches(':hover') && !item.matches(':focus-within')) {
          item.classList.remove('is-submenu-open');
        }
      }, 280);
    };

    item.addEventListener('pointerenter', openSubmenu);
    item.addEventListener('pointerleave', scheduleSubmenuClose);
    item.addEventListener('focusin', openSubmenu);
    item.addEventListener('focusout', scheduleSubmenuClose);
  });

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-buskins-menu-close]');
    if (closeButton) {
      closeButton.closest('details')?.removeAttribute('open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.buskins-header__mobile-menu[open]').forEach((menu) => {
        menu.removeAttribute('open');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
